import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import AnyeZwpc from './router/AnyeZwpc';
import AnyeZwwap from './router/AnyeZwwap';
import home from './router/home'
export default new VueRouter({
	mode:'history',
	routes:[
		{
			path:'/',
			component:AnyeZwpc,
			meta: {
            	title: '暗夜杯--首届全球华文泛悬疑大赛'
        	}
		},{
			path:'/home',
			component:home,
			meta: {
            	title: '首页'
        	}
		},{
            path:'/anye_zw',
            component:AnyeZwpc,
            meta: {
                title: '暗夜杯--首届全球华文泛悬疑大赛'
            }
        },{
            path:'/anye_zw_wap',
            component:AnyeZwwap,
            meta: {
                title: '暗夜杯--首届全球华文泛悬疑大赛'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router.config.js